import {
  SET_PRODUCT,
  SET_PLUGIN_INFO,
  SET_BRIEFS,
  SET_BRIEFS_LOADING,
  SET_ADOBE_RATING,
  SET_RATING_LOADING,
  SET_RATING_PAGINATION,
} from './product.constants';


const initialState = {
  briefs: [],
  briefsLoading: false,
  product: {},
  pluginInfo: {},
  adobeRating: [],
  ratingLoading: false,
  ratingPagination: 1,
};

const productReducer = (state = initialState, action) => {
  const { type, payload = {} } = action;

  switch (type) {
    case SET_BRIEFS: {
      return {
        ...state,
        briefs: payload,
      }
    }

    case SET_BRIEFS_LOADING: {
      return {
        ...state,
        briefsLoading: payload,
      }
    }

    case SET_PRODUCT: {
      return {
        ...state,
        product: payload,
      }
    }

    case SET_PLUGIN_INFO: {
      return {
        ...state,
        pluginInfo: payload,
      }
    }

    case SET_ADOBE_RATING: {
      return {
        ...state,
        adobeRating: payload,
      }
    }

    case SET_RATING_LOADING: {
      return {
        ...state,
        ratingLoading: payload,
      }
    }

    case SET_RATING_PAGINATION: {
      return {
        ...state,
        ratingPagination: payload,
      }
    }

    default:
      return state;
  }
};

export default productReducer;
